import { useEffect, useState } from "react";
import { FileClock } from "lucide-react";
import api from "@/lib/api";
import { Loader, fmtDateTime, EmptyState } from "@/components/shared";
import { AdminPageHeader } from "./adminShared";

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)); }, []);
  if (logs === null) return <Loader />;

  return (
    <div data-testid="admin-audit-logs">
      <AdminPageHeader eyebrow="Security" title="Audit Logs" subtitle="Immutable record of administrative actions" />
      {logs.length ? (
        <div className="glass rounded-2xl p-4 overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead><tr className="text-left text-slate-500 border-b border-white/5">
              {["Admin", "Action", "Target", "Target ID", "Date"].map((h) => <th key={h} className="pb-3 px-2 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-white/5 last:border-0" data-testid={`audit-row-${l.id}`}>
                  <td className="py-3 px-2 text-slate-300">{l.admin_email}</td>
                  <td className="py-3 px-2"><span className="px-2 py-1 rounded-md bg-cyan-500/10 text-cyan-300 text-xs font-mono capitalize">{l.action.replace(/_/g, " ")}</span></td>
                  <td className="py-3 px-2 text-slate-400 capitalize">{l.target_type}</td>
                  <td className="py-3 px-2 font-mono text-xs text-slate-500">{(l.target_id || "").slice(0, 12)}</td>
                  <td className="py-3 px-2 text-slate-500">{fmtDateTime(l.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <EmptyState icon={FileClock} title="No audit logs yet" subtitle="Admin actions will be recorded here." />}
    </div>
  );
}
